import { useRef, useState } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface TruncatedHeaderLabelProps {
  text: string;
}

/**
 * A column header label that ellipsizes when the column is too narrow and
 * shows the full text in a tooltip on hover — only while it is actually cut
 * off (checked at open time, so it tracks column resizes). Carries its own
 * `TooltipProvider` so the grid works in trees without the app-level one.
 */
export function TruncatedHeaderLabel({ text }: TruncatedHeaderLabelProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => {
    const el = ref.current;
    setOpen(next && !!el && el.scrollWidth > el.clientWidth);
  };

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={handleOpenChange}>
        <TooltipTrigger asChild>
          <span ref={ref} className="truncate">
            {text}
          </span>
        </TooltipTrigger>
        <TooltipContent>{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
